import { createContext } from 'react';
import { IModifierGroups } from 'types';

export type TSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error' | 'copyMenuModal';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface IModifierGroupsState {
	modifiersGroups: IModifierGroups;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const modifierGroupsInitialState: IModifierGroupsState = {
	modifiersGroups: { modifierGroupsCount: 0, modifierGroups: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IModifierGroupsContext extends IModifierGroupsState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDSelectedCustomer(value: Nullable<string>): void;
	setIDSelectedRestaurant(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const ModifierGroupsContext = createContext<IModifierGroupsContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDSelectedCustomer: () => undefined,
	setIDSelectedRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...modifierGroupsInitialState,
});
